import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { Button, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import { deleteProcedureHistoryThunk } from '../../../slices/thunks';
import { resetProcedureHistoryFlags } from '../../../slices/procedureHistory/reducer';

const DeleteProcedureHistoryModal = ({ dataProcedureHistory, isOpen, handlerToggleModal }) => {
	const dispatch = useDispatch();

	const selectorProcedureHistory = createSelector(
		state => state.ProcedureHistory,
		procedureHistory => ({
			isDeleting: procedureHistory?.isDeleting,
			isDeleted: procedureHistory?.isDeleted,
			isCloseModal: procedureHistory?.isCloseModal,
		})
	);

	const { isDeleting, isDeleted, isCloseModal } = useSelector(selectorProcedureHistory);

	useEffect(() => {
		if (isCloseModal && isDeleted) {
			handlerToggleModal();
			dispatch(resetProcedureHistoryFlags());
		}
	}, [isCloseModal, isDeleted]);

	const handleDelete = () => {
		if (dataProcedureHistory?._id) {
			dispatch(deleteProcedureHistoryThunk(dataProcedureHistory._id));
		}
	};

	return (
		<div>
			<Modal
				isOpen={isOpen}
				toggle={() => handlerToggleModal()}
				size='sm'
				className='border-0'
				modalClassName='modal fade zoomIn'
				backdrop={'static'}
				centered={true}
			>
				<ModalHeader className='modal-title' />
				<ModalBody className='text-center p-3'>
					<lord-icon
						src='https://cdn.lordicon.com/tdrtiskw.json'
						trigger='loop'
						colors='primary:#f06548,secondary:#405189'
						style={{ width: '90px', height: '90px' }}
					></lord-icon>
					<div className='mt-2'>
						<h3 className='mb-3'>
							¡Estás a punto de eliminar un Historial de Trámite!
						</h3>
						<p className='text-muted mb-4'>
							Si deseas realizar esta acción debes hacer click en confirmar.
						</p>
						<p className='small'>
							Trámite: {dataProcedureHistory !== null ? dataProcedureHistory?.name : ''}
						</p>
						<div className='hstack gap-2 justify-content-center'>
							<Button
								className='btn-danger btn-label'
								onClick={() => handlerToggleModal()}
							>
								<i className='ri-close-line label-icon'></i> Cancelar
							</Button>
							<button
								className='btn btn-label btn-primary'
								onClick={() => handleDelete()}
								disabled={isDeleting}
							>
								{isDeleting ? (
									<i className='label-icon'><Spinner size='sm' /></i>
								) : (
									<i className='ri-check-double-line label-icon'></i>
								)} Confirmar
							</button>
						</div>
					</div>
				</ModalBody>
			</Modal>
		</div>
	);
};

export default DeleteProcedureHistoryModal;
